'use strict';

angular.module('app').directive('mobileHover', function ($window, utils) {
    return function (scope, element, attrs) {
      var timer,
          leaveTimer,
          delay = utils.isMobile() ? 0 : 500,
          $elem = $(element);

      $elem.on({
          mouseenter: function () {
              clearTimeout(leaveTimer);
              timer = setTimeout(function () {
                  $elem.addClass('active');
              }, delay);
          },
          mouseleave : function () {
              clearTimeout(timer);
              leaveTimer = setTimeout(function(){
                $elem.removeClass('active');
              }, delay);
          }
      });
    }
});
